module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABIUlEQVQoka2Su0tCYRjG/WOiD2kqWvsfoqU+aTm5OTVFBIJUn2fQBoda7AJFJgR2GYwuEFpLEBl+NEQGFXbDCuziOZryaxMX7RgNz/Ly/uB9n+dxaa35i1ztLGdyKRZ3AlzcnDgHo0k/Q9OdBJYlV/nz38HX90fG5/uRSnBwFufp7Zbyt9Ua/LKKTCwMIJUgk0tRrVWd/RiMGUglONbbzs1JZzeQShBJjDZ3NZr0s3e6Wh/aFQtfpA9P0E2h+NAclEogleDu+RKtNYmjWaQSLO1Ots5xbmsMqQRmbIR8Icew2YUR6sYqf7YG71+u8QTddVgqwcq+6aw54XVf/WRvuBe7UnIGluwPjFAPg1MdxA9n2utqOruJueal1hD0v5S8UT97mrD+3sPnSwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/TeachersComponent/KSGrading/style/images_WordMark/current_correct.png
// module id = 387
// module chunks = 0